<template>
  <b-container class="report py-2 py-lg-4">
    <h1>Gerar relatório</h1>
    <report-form
      class="no-print"
      :initialOptions="this.initialReportOptions"
      @success="result => report = result"
      @error="err => error = err.message"
      @reset="report = null; error = null;"
      />

    <div class="mt-3"></div>
    <report-result v-if="report" :report="report"
                   @export="track('', 'Exportou relatório')"
                   @print="track('', 'Imprimiu relatório')"/>

    <div v-if="error" class="d-flex align-items-center justify-content-center p-3 border-lg-dark">
      <img src="@/assets/failure.svg" alt="Erro" class="mr-2">
      <span>{{ error }}</span>
    </div>
  </b-container>
</template>

<script>
import ReportForm from '@/components/ReportForm';
import ReportResult from '@/components/ReportResult';

export default {
  name: 'Report',
  components: {
    ReportForm,
    ReportResult,
  },
  data() {
    return {
      initialReportOptions: this.$route.params.initialReportOptions,
      report: null,
      error: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.report {
  background-color: $bg-default;
  color: $text-dark;

  @media screen and (max-width: $lg - 1px) {
    max-width: 100%!important;
  }
}
</style>
